import cPaymentSummary from '#themes/default/default/components/paymentSummary/paymentSummary.js';
import cPriceTable from '#themes/default/default/components/priceTable/priceTable.js';

import template from './orderSummary.html' with { type: 'html' };

export default {
	name: 'COrderSummary',
	components: {
		cPaymentSummary,
		cPriceTable
	},
	props: {
		customer: {
			type: Object,
			default: () => null
		},
		form: {
			type: Object,
			default: () => null
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		},
		isThankYouPage: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		productNotes() {
			return this.order.products.reduce((acc, product) => {
				// Remove link from the product description
				let productNote = product.note.replace(/<a.+?>|<\/a>/g, '');
				// Add quantity to the business product description
				if (product.isBusiness) {
					let quantityNote;
					if (product.quantityAs === 'usage') {
						// Default usage base value (e.g. 100 as 100 GB)
						const usageBase = product.usageBase;
						// Use "GB" if usage base provided, else use "units" localization
						quantityNote = usageBase ? this.t('orderSummary_quantityUsage', {
							quantity: product.quantity * usageBase
						}) : this.t('orderSummary_quantityUnits', {
							quantity: product.quantity
						});
					} else {
						quantityNote = this.t('orderSummary_quantityDevices', {
							quantity: product.quantity
						});
					}
					productNote = `${quantityNote} ${productNote}`;
				}
				return {
					...acc,
					[product.id]: productNote
				};
			}, {});
		},
		showFuturePrice() {
			const hasAutoRenewal = this.selectedPayment && this.order && !(this.selectedPayment.isManualRenewal || this.order.hasManualRenewalProduct);
			const hasBusinessProduct = this.order.hasBusinessProduct;
			return this.theme.variables.hasFuturePrice && hasAutoRenewal && !hasBusinessProduct;
		}
	},
	template
};
